import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { BiLinkExternal } from "react-icons/bi";
import "../../style.css";

function ProjectCards({
  imgPath,
  title,
  description,
  repositoryLink,
  live,
  liveLink,
  front,
  back,
}) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>{description}</Card.Text>
        <div className="tech-stack">
          <div className="front-end">
            {front ? (
              <Card.Text>
                <Card.Title>Front End</Card.Title>

                {front?.map((tech) => (
                  <p className="tech">{tech}</p>
                ))}
              </Card.Text>
            ) : null}
          </div>
          <div className="back-end">
            {back ? (
              <Card.Text>
                <Card.Title>Back End</Card.Title>
                {back?.map((tech) => (
                  <p className="tech">{tech}</p>
                ))}
              </Card.Text>
            ) : null}
          </div>
        </div>
      </Card.Body>
      <div className="Buttons-project-Container">
        <Button variant="primary" href={repositoryLink} target="_blank">
          <BiLinkExternal /> &nbsp;
          {"View Repository"}
        </Button>
        {live ? (
          <Button variant="third" href={liveLink} target="_blank">
            <BiLinkExternal /> &nbsp;
            {"View Project"}
          </Button>
        ) : null}
      </div>
    </Card>
  );
}
export default ProjectCards;
